import '../css'
import '../css/actiontext.css'

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

import 'trix'
import '@rails/actiontext'

$(function() {
  $('*[data-toggle="tooltip"]').tooltip()
  $('select.select2').select2()
})
